import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import NumberFormat from 'react-number-format';
import {
  Icon,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import { deleteSubscriptionCouponCodeApi } from 'api';
import { ConfirmDialog } from 'components';
import { storeTypeNameUI } from 'helpers/storeTypeNames';
import SubscriptionCouponCodeForm from './SubscriptionCouponCodeForm';


const AccessCodesList = ({codes, catalogStoreCodes}) => {
  const dispatch = useDispatch();
  const [openConfirmDeleteCode, toggleConfirmDeleteCode] = useState(false);
  const [openEditCodeDialog, toggleEditCodeDialog] = useState(false);
  const [currentCodeId, setCurrentCodeId] = useState(null);

  const editableCodeData = currentCodeId && codes.find((code) => code._id === currentCodeId);

  const handleDeleteCode = () => {
    deleteSubscriptionCouponCodeApi({dispatch, id: currentCodeId});
    toggleConfirmDeleteCode(false);
  };

  const columns = [
    {
      name: 'code',
      label: 'Access Code',
    },
    {
      name: 'catalogStoreView',
      label: 'Catalog Store Code',
      options: {
        setCellProps: () =>  ({className: 'capitalize'})
      }
    },
    {
      name: 'storeType',
      label: 'Store Type',
      options: {
        setCellProps: () =>  ({className: 'capitalize'}),
        customBodyRenderLite: (dataIndex) => {
          const {storeType} = codes[dataIndex];
          return <div>{storeTypeNameUI[storeType]}</div>;
        }
      }
    },
    {
      name: 'discountOneTime',
      label: (
        <div>One Time <br />Price Reduction</div>
      ),
      options: {
        customBodyRenderLite: (dataIndex) => {
          const {discountOneTime} = codes[dataIndex];
          return (
            <NumberFormat
              value={discountOneTime}
              displayType="text"
              thousandSeparator={','}
              decimalSeparator={'.'}
              prefix={'$'}
              fixedDecimalScale
              decimalScale={2}
            />
          );
        }
      }
    },
    {
      name: 'discountMonthly',
      label: (
        <div>Monthly Subscription <br />Price Reduction</div>
      ),
      options: {
        customBodyRenderLite: (dataIndex) => {
          const {discountMonthly} = codes[dataIndex];
          return (
            <NumberFormat
              value={discountMonthly}
              displayType="text"
              thousandSeparator={','}
              decimalSeparator={'.'}
              prefix={'$'}
              fixedDecimalScale
              decimalScale={2}
            />
          );
        }
      }
    },
    {
      name: 'isUsed',
      label: 'Is Used',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const {isUsed} = codes[dataIndex];
          return (
            <div>
              {isUsed ? 'Already used' : 'Not used yet'}
            </div>
          );
        }
      }
    },
    {
      name: 'createdAt',
      label: 'Created At',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          const createdAt = new Date(codes[dataIndex].createdAt);
          return (
            <>{createdAt.toLocaleString()}</>
          );
        }
      }
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        sort: false,
        setCellHeaderProps: () => ({className: 'text-right pr-8 text-14', style: {width: '13%'}}),
        customBodyRenderLite: (dataIndex) => {
          const {_id, isUsed} = codes[dataIndex];

          return (
            <div className="text-right">
              <IconButton
                title="Delete"
                disabled={isUsed}
                onClick={() => {
                  toggleConfirmDeleteCode(true);
                  setCurrentCodeId(_id);
                }}
              >
                <Icon>delete</Icon>
              </IconButton>
              <IconButton
                title="Edit"
                className="ml-2"
                disabled={isUsed}
                onClick={() => {
                  setCurrentCodeId(_id);
                  toggleEditCodeDialog(true);
                }}
              >
                <Icon>edit</Icon>
              </IconButton>
            </div>
          );
        }
      }
    }
  ];

  return (
    <>
      <MUIDataTable
        data={codes}
        columns={columns}
        options={{
          responsive: 'standard',
          selectableRows: 'none',
          search: false,
          filter: false,
          download: false,
          print: false,
          pagination: true,
          viewColumns: false,
          elevation: 0,
          rowsPerPage: 20,
          rowsPerPageOptions: [20, 40, 80, 100],
          textLabels: {
            body: {
              noMatch: 'No Referral Codes Available',
            }
          },
          sortOrder: {
            name: 'createdAt',
            direction: 'desc'
          }
        }}
      />
      {editableCodeData &&
      <>
        <ConfirmDialog
          title={`Delete ${editableCodeData.code} Access Code?`}
          open={openConfirmDeleteCode}
          setOpen={toggleConfirmDeleteCode}
          onConfirm={handleDeleteCode}
        >
          Are you sure you want to delete this access code?
          This action cannot be reverted back.
        </ConfirmDialog>
        <Dialog
          open={openEditCodeDialog && Boolean(editableCodeData)}
          onClose={() => toggleEditCodeDialog(!openEditCodeDialog)}
          aria-label="edit-access-code"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <div className="flex items-center justify-between">
              <Typography variant="h4" className="h4">
                Edit {editableCodeData.code} Access Code
              </Typography>
              <IconButton
                onClick={() => toggleEditCodeDialog(!openEditCodeDialog)}
              >
                <Icon>close</Icon>
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <SubscriptionCouponCodeForm
              editableCodeData={editableCodeData}
              catalogStoreCodes={catalogStoreCodes}
              toggleCouponCodeForm={toggleEditCodeDialog}
            />
          </DialogContent>
        </Dialog>
      </>
      }
    </>
  );
};

export default AccessCodesList;
